module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "col-md-10"
  }, [_c('a', {
    on: {
      "click": _vm.navigatoToBuyCredit
    }
  }, [_vm._v(" Seus créditos estão acabando, faça uma recarga! "), _c('strong', [_vm._v(" Saldo: " + _vm._s(_vm._f("money")(this.alert.balance)) + " ")])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-window-close icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "space-50"
  }), _vm._v(" "), _c('small', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.alert.date)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7be53da8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/general_notification_components/BalanceAlertNotification.vue
// module id = 843
// module chunks = 2